import React, { useState } from 'react';
import { Link } from 'react-router-dom';
//import ChatIcon from '@mui/icons-material/Chat';
import { useUser } from '../../context/UserContext';
import packageJson from '../../../../ClientApp/package.json';

export default function Footer() {
  const user = useUser();
  return (
    <footer className="border-top footer text-muted">
      <div className="container">
        &copy; 2020-2024 The Baltimore Life Insurance Company Agent Portal -{' '}
        <a href="https://www.baltlife.com/legal-notices" target="_blank" rel="noreferrer">
          Legal Notices
        </a>{' '}
        - Version: {packageJson.version}
        {/*{Object.keys(user.permissions).length > 0 &&*/}
        {/*    <div className="fab-container">*/}
        {/*        <div className="chatbutton iconbutton" style={{ backgroundImage: "url(/images/chat.png)" }} onClick={() => { ciscoBubbleChat.showChatWindow() }}>*/}
        {/*        </div>*/}
        {/*    </div>*/}
        {/*}                */}
      </div>
    </footer>
  );
}
